export type SAAppPlatform =
  | 'android'
  | 'iphone'
  | 'android-tv'
  | 'fire-tv'
  | 'samsung-tv'
  | 'lg-tv';

export interface SAApp {
  id: string;
  platform: SAAppPlatform;
  version: string;
  status: 'live' | 'beta' | 'review' | 'maintenance';
  downloads: number;
  lastUpdated: string;
  downloadUrl: string;
  packageName: string;
  minOsVersion: string;
  size: string;
}

export const saAppPlatformMeta: Record<SAAppPlatform, { label: string; icon: string; storeName: string }> = {
  'android':     { label: 'Android',     icon: 'ri-android-line',       storeName: 'Google Play' },
  'iphone':      { label: 'iPhone',      icon: 'ri-apple-line',         storeName: 'App Store' },
  'android-tv':  { label: 'Android TV',  icon: 'ri-android-line',       storeName: 'Google Play TV' },
  'fire-tv':     { label: 'Fire TV',     icon: 'ri-fire-line',          storeName: 'Amazon Appstore' },
  'samsung-tv':  { label: 'Samsung TV',  icon: 'ri-tv-line',            storeName: 'Samsung Apps' },
  'lg-tv':       { label: 'LG TV',       icon: 'ri-tv-2-line',          storeName: 'LG Content Store' },
};

export const saAppStatusMeta: Record<SAApp['status'], { label: string; color: string; bgColor: string }> = {
  live:        { label: 'En producción',  color: 'text-emerald-600', bgColor: 'bg-emerald-100' },
  beta:        { label: 'Beta',           color: 'text-amber-600',   bgColor: 'bg-amber-100' },
  review:      { label: 'En revisión',    color: 'text-sky-600',     bgColor: 'bg-sky-100' },
  maintenance: { label: 'Mantenimiento',  color: 'text-red-600',     bgColor: 'bg-red-100' },
};

export const saApps: SAApp[] = [
  {
    id: 'app-android',
    platform: 'android',
    version: '4.3.1',
    status: 'live',
    downloads: 284500,
    lastUpdated: '2026-06-12',
    downloadUrl: 'https://play.google.com/store/apps/details?id=com.rfw.app',
    packageName: 'com.rfw.app',
    minOsVersion: 'Android 8.0+',
    size: '28.4 MB',
  },
  {
    id: 'app-iphone',
    platform: 'iphone',
    version: '4.3.1',
    status: 'live',
    downloads: 198200,
    lastUpdated: '2026-06-12',
    downloadUrl: 'https://apps.apple.com/app/radiofrecuenciaweb/id1234567890',
    packageName: 'com.rfw.ios',
    minOsVersion: 'iOS 15.0+',
    size: '32.1 MB',
  },
  {
    id: 'app-android-tv',
    platform: 'android-tv',
    version: '2.1.0',
    status: 'live',
    downloads: 41200,
    lastUpdated: '2026-05-28',
    downloadUrl: 'https://play.google.com/store/apps/details?id=com.rfw.tv',
    packageName: 'com.rfw.tv',
    minOsVersion: 'Android TV 9.0+',
    size: '18.7 MB',
  },
  {
    id: 'app-fire-tv',
    platform: 'fire-tv',
    version: '2.1.0',
    status: 'review',
    downloads: 28300,
    lastUpdated: '2026-06-08',
    downloadUrl: 'https://www.amazon.com/dp/B0ABCDEFGH',
    packageName: 'com.rfw.firetv',
    minOsVersion: 'Fire OS 7+',
    size: '19.2 MB',
  },
  {
    id: 'app-samsung-tv',
    platform: 'samsung-tv',
    version: '1.8.2',
    status: 'live',
    downloads: 15600,
    lastUpdated: '2026-04-15',
    downloadUrl: 'https://apps.samsung.com/app/radiofrecuenciaweb',
    packageName: 'com.rfw.samsungtv',
    minOsVersion: 'Tizen 6.0+',
    size: '22.3 MB',
  },
  {
    id: 'app-lg-tv',
    platform: 'lg-tv',
    version: '1.5.0',
    status: 'beta',
    downloads: 4200,
    lastUpdated: '2026-06-01',
    downloadUrl: 'https://us.lgappstv.com/app/radiofrecuenciaweb',
    packageName: 'com.rfw.lgtv',
    minOsVersion: 'webOS 5.0+',
    size: '21.8 MB',
  },
];

export const totalDownloads = saApps.reduce((sum, a) => sum + a.downloads, 0);